module.exports = __webpack_public_path__ + "img/ps-adicciones.5b2780ad.jpg";